import { XCircleIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import type { RootState } from '../../../store';
import { submitOpportunity } from '../../../store/Opportunity';
import BaseLineInfo from '../Form/BaseLineInfo';
import Incentive from '../Form/Incentive';
import MileStoneSchedule from '../Form/MileStoneSchedule';
import PriliminaryProgram from '../Form/PreliminaryProgram';
import ProjectSource from '../Form/ProjectSource';
import ProjectTeam from '../Form/ProjectTeam';
import ProjectUses from '../Form/ProjectUses';
import FormReview from '../Form/Review';
import Vendor from '../Form/Vendor';
import styles from './New.module.css';

export default function NewOpportunity() {
  const [currentStep, updateStep] = useState(0);
  const navigate = useNavigate();
  const [_showCancelConfirm, setShowCancelCofirm] = useState(false);
  const opportunityStateRoot = useSelector((state: RootState) => state.opportunity.opportunityMain);
  const dispatch = useDispatch();

  const handleProgress = () => {
    updateStep(currentStep + 1);
  };

  const handleSubmit = () => {
    dispatch(submitOpportunity() as any);
  };

  const closeFormHandler = () => {
    setShowCancelCofirm(true);
    //TO DO: handling confirm modal
    navigate('/app/rover/opportunities');
  };

  if (opportunityStateRoot.submitSuccess) {
    setTimeout(() => {
      navigate(`/opportunities/${opportunityStateRoot.createdID}`);
      window.scrollTo(0, 0);
    }, 3000);
  }

  const _renderError = () => {
    return (
      <div className='overflow-hidden leading-normal rounded-lg' role='alert'>
        <p className='px-4 py-3 font-bold text-red-100 bg-red-800'>We couldn't save provided opportunity details!</p>
        <p className='px-4 py-3 text-red-700 bg-red-100 '>
          <ul className='list-disc list-inside'>
            <li>Project Team must contain atleast one member.</li>
          </ul>
        </p>
      </div>
    );
  };

  const renderSuccess = () => {
    return (
      <div className='overflow-hidden leading-normal rounded-lg' role='alert'>
        <p className='px-4 py-3 font-bold bg-green-600 text-white'>
          Opportunity successfully created. You will be now redirected to opportunity dashboard.
        </p>
      </div>
    );
  };

  function _ui() {
    return (
      <div className='max-w-6xl mx-auto relative'>
        <div className='flex mt-4 bg-white rounded-md shadow-xl'>
          <ul className={styles.menu}>
            <li className={`${currentStep === 0 && styles.selected}`} onClick={() => updateStep(0)}>
              <span> Baseline Opportunity Information</span>
            </li>

            {/* <li className="">
              <div
                className={`${
                  currentStep == 0 && styles.selected
                }`}

                onClick={() => updateStep(0)}
              >
                <span className="ml-2 flex-1 w-0 truncate">
                  Baseline Opportunity Information
                </span>
              </div>
            </li> */}
            <li className={`${currentStep === 1 && styles.selected}`} onClick={() => updateStep(1)}>
              <span className='ml-2 flex-1 w-0'>Preliminary Program</span>
            </li>

            <li className=''>
              <div
                className={`block pl-3 pr-4 py-3 text-sm ${currentStep === 2 && 'bg-green-900 text-white'}`}
                onClick={() => updateStep(2)}
              >
                <span className='ml-2 flex-1 w-0 truncate'>Project Uses</span>
              </div>
            </li>
            <li className=''>
              <div
                className={`block pl-3 pr-4 py-3 text-sm ${currentStep === 3 && 'bg-green-900 text-white'}`}
                onClick={() => updateStep(3)}
              >
                <span className='ml-2 flex-1 w-0 truncate'>Project Sources</span>
              </div>
            </li>
            <li className=''>
              <div
                className={`block pl-3 pr-4 py-3 text-sm ${currentStep === 4 && 'bg-green-900 text-white'}`}
                onClick={() => updateStep(4)}
              >
                <span className='ml-2 flex-1 w-0 truncate'>MileStone Schedule</span>
              </div>
            </li>
            <li className=''>
              <div
                className={`block pl-3 pr-4 py-3 text-sm ${currentStep === 5 && 'bg-green-900 text-white'}`}
                onClick={() => updateStep(5)}
              >
                <span className='ml-2 flex-1 w-0 truncate'>Project Team</span>
              </div>
            </li>
            <li className=''>
              <div
                className={`block pl-3 pr-4 py-3 text-sm ${currentStep === 6 && 'bg-green-900 text-white'}`}
                onClick={() => updateStep(6)}
              >
                <span className='ml-2 flex-1 w-0 truncate'>Vendor</span>
              </div>
            </li>
            <li className=''>
              <div
                className={`block pl-3 pr-4 py-3 text-sm ${currentStep === 7 && 'bg-green-900 text-white'}`}
                onClick={() => updateStep(7)}
              >
                <span className='ml-2 flex-1 w-0 truncate'>Incentives</span>
              </div>
            </li>
            <li className=''>
              <div
                className={`block pl-3 pr-4 py-3 text-sm ${currentStep === 8 && 'bg-green-900 text-white'}`}
                onClick={() => updateStep(8)}
              >
                <span className='ml-2 flex-1 w-0 truncate'>Review</span>
              </div>
            </li>
          </ul>
          <form className={'relative p-10 w-full border-l-2'}>
            <span
              className='absolute text-neutralColor-normal top-4 right-4 hover:text-neutralColor-dark cursor-pointer'
              onClick={closeFormHandler}
            >
              <XCircleIcon className='h-6 w-6' />
            </span>
            {currentStep === 0 && <BaseLineInfo />}
            {currentStep === 1 && <PriliminaryProgram />}
            {currentStep === 2 && <ProjectUses />}
            {currentStep === 3 && <ProjectSource />}
            {currentStep === 4 && <MileStoneSchedule />}
            {currentStep === 5 && <ProjectTeam />}
            {currentStep === 6 && <Vendor />}
            {currentStep === 7 && <Incentive />}
            {currentStep === 8 && <FormReview updateStep={updateStep} />}

            {/* {opportunityStateRoot.submitError && renderError()} */}
            {opportunityStateRoot.submitSuccess && renderSuccess()}
            <div className='my-12 flex items-center justify-end'>
              {currentStep > 0 && (
                <button type='button' className='form-submit-alt inline-flex items-center' onClick={() => updateStep(currentStep - 1)}>
                  <svg xmlns='http://www.w3.org/2000/svg' className='h-5 w-5 mr-2' viewBox='0 0 20 20' fill='currentColor'>
                    <path
                      fillRule='evenodd'
                      d='M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z'
                      clipRule='evenodd'
                    />
                  </svg>{' '}
                  Back
                </button>
              )}

              {currentStep < 8 && (
                <button type='button' onClick={handleProgress} className='form-submit-primary inline-flex ml-4'>
                  Next
                </button>
              )}
              {currentStep >= 8 && (
                <button
                  type='button'
                  onClick={handleSubmit}
                  className={'form-submit-primary inline-flex ml-4'}
                  disabled={opportunityStateRoot.submitSuccess}
                >
                  {opportunityStateRoot.submitting ? 'Submitting' : opportunityStateRoot.submitSuccess ? 'Submitted' : 'Submit'}
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className='max-w-6xl mx-auto relative'>
      <h1>New Opportunity</h1>
      <div className='flex mt-4 bg-white rounded-md shadow-xl'>
        <ul className={styles.menu}>
          <li className={`${currentStep === 0 && styles.selected}`} onClick={() => updateStep(0)}>
            <span> Baseline Opportunity Information</span>
          </li>

          <li className={`${currentStep === 1 && styles.selected}`} onClick={() => updateStep(1)}>
            <span className='ml-2 flex-1 w-0'>Preliminary Program</span>
          </li>
          <li className={`${currentStep === 2 && styles.selected}`} onClick={() => updateStep(2)}>
            <span className='ml-2 flex-1 w-0 truncate'>Project Uses</span>
          </li>

          <li className={`${currentStep === 3 && styles.selected}`} onClick={() => updateStep(3)}>
            <span className='ml-2 flex-1 w-0 truncate'>Project Sources</span>
          </li>
          <li className={`${currentStep === 4 && styles.selected}`} onClick={() => updateStep(4)}>
            <span className='ml-2 flex-1 w-0 truncate'>MileStone Schedule</span>
          </li>

          <li className={`${currentStep === 5 && styles.selected}`} onClick={() => updateStep(5)}>
            <span className='ml-2 flex-1 w-0 truncate'>Project Team</span>
          </li>

          <li className={`${currentStep === 6 && styles.selected}`} onClick={() => updateStep(6)}>
            <span className='ml-2 flex-1 w-0 truncate'>Vendor</span>
          </li>
          <li className={`${currentStep === 7 && styles.selected}`} onClick={() => updateStep(7)}>
            <span className='ml-2 flex-1 w-0 truncate'>Incentives</span>
          </li>

          <li className={`${currentStep === 8 && styles.selected}`} onClick={() => updateStep(8)}>
            <span className='ml-2 flex-1 w-0 truncate'>Review</span>
          </li>
        </ul>
        <form className={'relative p-10 w-full border-l-2'}>
          <span
            className='absolute text-neutralColor-normal top-4 right-4 hover:text-neutralColor-dark cursor-pointer'
            onClick={closeFormHandler}
          >
            <XCircleIcon className='h-6 w-6' />
          </span>
          {currentStep === 0 && <BaseLineInfo />}
          {currentStep === 1 && <PriliminaryProgram />}
          {currentStep === 2 && <ProjectUses />}
          {currentStep === 3 && <ProjectSource />}
          {currentStep === 4 && <MileStoneSchedule />}
          {currentStep === 5 && <ProjectTeam />}
          {currentStep === 6 && <Vendor />}
          {currentStep === 7 && <Incentive />}
          {currentStep === 8 && <FormReview updateStep={updateStep} />}

          {/* {opportunityStateRoot.submitError && renderError()} */}
          {opportunityStateRoot.submitSuccess && renderSuccess()}
          <div className='my-12 flex items-center justify-end'>
            {currentStep > 0 && (
              <button type='button' className='form-submit-alt inline-flex items-center' onClick={() => updateStep(currentStep - 1)}>
                <svg xmlns='http://www.w3.org/2000/svg' className='h-5 w-5 mr-2' viewBox='0 0 20 20' fill='currentColor'>
                  <path
                    fillRule='evenodd'
                    d='M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z'
                    clipRule='evenodd'
                  />
                </svg>{' '}
                Back
              </button>
            )}

            {currentStep < 8 && (
              <button type='button' onClick={handleProgress} className='form-submit-primary inline-flex ml-4'>
                Next
              </button>
            )}
            {currentStep >= 8 && (
              <button
                type='button'
                onClick={handleSubmit}
                className={'form-submit-primary inline-flex ml-4'}
                disabled={opportunityStateRoot.submitSuccess}
              >
                {opportunityStateRoot.submitting ? 'Submitting' : opportunityStateRoot.submitSuccess ? 'Submitted' : 'Submit'}
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}
